import React, { useEffect, useCallback, useRef } from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { Typography } from 'design-component';
import { palette } from 'styles/color';
import { IconClose } from 'assets/icon';
import { initToast, selectToast } from 'store/slices/toastSlice';
import { useAppDispatch, useAppSelector } from 'store/store';

const Toast: React.FC = () => {
  const dispatch = useAppDispatch();
  const toast = useAppSelector(selectToast);
  const timer = useRef<null | ReturnType<typeof setTimeout>>(null);
  const closeToast = useCallback(() => dispatch(initToast()), [dispatch]);

  useEffect(() => {
    if (!toast.infinity && toast.type !== 'none') {
      clearTimeout(timer.current as ReturnType<typeof setTimeout>); // 이전 타이머 클리어

      timer.current = setTimeout(() => {
        closeToast();
      }, 3500); // 기본 노출 시간 3.5초
    }

    return () => {
      clearTimeout(timer.current as ReturnType<typeof setTimeout>);
    };
  }, [toast, closeToast]);

  if (toast.type === 'none') return null;

  return (
    <ToastContainer
      style={{ backgroundColor: toast.type === 'error' ? palette.red : palette.black }}>
      <Content>
        <Typography
          component="div"
          size="14px"
          height="18px"
          weight={700}
          color={palette.white}
          style={{
            width: '260px',
            whiteSpace: 'pre-wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-block'
          }}
          className="toast-message"
          // dangerouslySetInnerHTML={{ __html: toast.msg ?? '' }}
        >
          {toast.msg ? parse(String(toast.msg)) : ''}
        </Typography>
      </Content>
      <Typography
        component="div"
        size="20px"
        height="18px"
        color={palette.white}
        style={{ cursor: 'pointer' }}
        onClick={closeToast}>
        <IconClose />
      </Typography>
    </ToastContainer>
  );
};

export default Toast;

const ToastContainer = styled.div`
  width: 328px;
  min-height: 54px;
  padding: 18px 20px;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: ${palette.black};
  opacity: 0.7;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  transition: opacity 0.3s;
  z-index: 999;
`;

const Content = styled.div`
  flex: 1;

  .toast-message > a {
    display: inline;
    color: ${palette.blue[500]};
    text-decoration: underline;
  }
`;
